import React, { useState, useEffect } from 'react';
import txtIcon from '../assets/icons/document_01.png';
import pdfIcon from '../assets/icons/document_02.png';
import './LogContents.css';
import { soundService } from '../services/SoundService.ts';

interface LogContentsProps {
  onOpenFile: (type: string, filename: string, windowType: string) => void;
}

const LogContents: React.FC<LogContentsProps> = ({ onOpenFile }) => {
  const [columns, setColumns] = useState(2);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 750) {
        setColumns(2);
      } else if (width < 920) {
        setColumns(3);
      } else {
        setColumns(4);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    soundService.init();
  }, []);

  const icons = [
    { src: txtIcon, alt: 'txtIcon', id: 'log-00', text: 'prologue', type: 'txt', isJapanese: false },
    { src: txtIcon, alt: 'txtIcon', id: 'log-01', text: '#01 me', type: 'txt', isJapanese: false },
    { src: txtIcon, alt: 'txtIcon', id: 'log-02', text: '#02 routine', type: 'txt', isJapanese: false },
    { src: txtIcon, alt: 'txtIcon', id: 'log-03', text: '#03 room', type: 'txt', isJapanese: false },
    { src: txtIcon, alt: 'txtIcon', id: 'log-04', text: '#04 test', type: 'txt', isJapanese: false },
    { src: txtIcon, alt: 'txtIcon', id: 'log-05', text: '#05 sing in your world', type: 'txt', isJapanese: false },
    { src: txtIcon, alt: 'txtIcon', id: 'log-06', text: '# -01 she', type: 'txt', isJapanese: false },
    { src: txtIcon, alt: 'txtIcon', id: 'log-07', text: '映像記録_1', type: 'txt', isJapanese: true },
    { src: txtIcon, alt: 'txtIcon', id: 'log-08', text: 'education_video.mp4', type: 'txt', isJapanese: true },
    { src: pdfIcon, alt: 'pdfIcon', id: 'pdf-somunia', text: 'somuniaの身体について', type: 'pdf', isJapanese: true },
    { src: pdfIcon, alt: 'pdfIcon', id: 'pdf-room', text: '部屋について', type: 'pdf', isJapanese: true },
    { src: pdfIcon, alt: 'pdfIcon', id: 'pdf-transporter', text: '転送装置', type: 'pdf', isJapanese: true },
    { src: pdfIcon, alt: 'pdfIcon', id: 'pdf-modisc', text: 'MODisc', type: 'pdf', isJapanese: false },
    { src: pdfIcon, alt: 'pdfIcon', id: 'pdf-transfer-event', text: '不明なソフトによる転移事象', type: 'pdf', isJapanese: true }
  ];

  return (
    <div className="log-contents-container" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
      {icons.map((icon, index) => (
        <div 
          key={index} 
          className="icon-container"
          onClick={(e) => {
            e.stopPropagation();
            soundService.playClickSound();
            onOpenFile(icon.type, icon.text, `file-viewer-${icon.type}`);
          }}
        >
          <img src={icon.src} alt={icon.alt} className="log-contents-image" />
          <span 
            className={`log-contents-icon-text message-text ${icon.isJapanese ? 'japanese' : ''}`} 
            title={icon.text}
          >
            {icon.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default LogContents; 